"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREFERENCES_SET_FAILED = exports.PREFERENCES_GET_FAILED = exports.ADDRESS_GET_FAILED = exports.NO_WALLETS = void 0;
exports.NO_WALLETS = 'NO_WALLETS';
exports.ADDRESS_GET_FAILED = 'Error getting address';
exports.PREFERENCES_GET_FAILED = 'Error getting preferences';
exports.PREFERENCES_SET_FAILED = 'Error setting wallet preferences';
